import { RemoteGetUserById } from 'data/usecases';
import { makeApiUrlUsers } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetUserById = (): RemoteGetUserById => {
  return new RemoteGetUserById(makeApiUrlUsers(), makeAxiosHttpClient());
};
